<template>
  <div id="dettaglio">
    <div v-if="qntyProd " class="righeRiepilogo row">
      <router-link v-if="wine.typology === 1" :to="{name: 'schedavini', params: {id: wine.idProduct, language: 'ita'}}"
                   class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 carlink">
        <div id="imgVino">
          <img :src="'static/image/products/'+wine.image+'Shop.png'" class="vinello">
        </div>
      </router-link>
      <router-link v-if="wine.typology === 2" :to="{name: 'smartbox', params: {id: wine.idProduct, language: 'ita'}}"
                   class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 carlink">
        <div id="imgVino">
          <img :src="'static/image/products/'+wine.image" class="smartbox">
        </div>
      </router-link>
      <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-3 nomeVino">{{wine.nome}}</div>
      <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 price1">{{wine.price.toFixed(2)}} &euro;</div>
      <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 quantity">Qtà:&nbsp; <input type="number" name="quantity"
                                                                                        min="1" :max="wine.qntyProd"
                                                                                        class="quantità" id="qua"
                                                                                        oninput="validity.valid||(value=1)"
                                                                                        v-model="qntyOrd"
                                                                                        v-validate="'required'"
                                                                                        @change="updateCart">
        <!--@change="changed = true"-->
      </div>
      <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 price" v-if="subTot !== 0">{{subTot.toFixed(2)}} &euro;
      </div>
      <div class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-1 remove"><img src="../../static/image/cancel.png"
                                                                         class="logo"
                                                                         @click="removeFromCart"></div>
    </div>
    <div v-if="!qntyProd" class="righeRiepilogo row">
      <router-link :to="{name: 'schedavini', params: {id: wine.idProduct, language: 'ita'}}"
                   class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 carlink">
        <div id="imgVino">
          <img :src="'static/image/products/'+wine.image+'Shop.png'" v-if="wine.typology === 1" class="notVinello">
          <img :src="'static/image/products/'+wine.image" v-if="wine.typology === 2" class="notSmartbox">
        </div>
      </router-link>
      <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-3 nomeVino">{{wine.nome}}</div>
      <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-4 notAvailable" v-if="wine.typology === 1">Quantità non disponibile, per procedere
        all'acquisto modifica la quantità di questo vino o rimuovilo dal carrello
      </div>
      <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-4 notAvailable" v-if="wine.typology === 2">Quantità non disponibile, per procedere
        all'acquisto modifica la quantità di questo pacchetto o rimuovilo dal carrello
      </div>
      <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 quantity">Qtà:&nbsp; <input type="number" name="quantity"
                                                                                        min="1" :max="wine.qntyProd"
                                                                                        class="quantità" id="qua"
                                                                                        oninput="validity.valid||(value=1)"
                                                                                        v-model="qntyOrd"
                                                                                        v-validate="'required'"
                                                                                        @change="updateCart"></div>
      <div class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-1 remove"><img src="../../static/image/cancel.png"
                                                                         class="logo"
                                                                         @click="removeFromCart"></div>
    </div>
  </div>
</template>

<script>
  import Bus from './Bus'

  export default {
    name: "dettagliocarrello",
    data() {
      return {
        qntyOrd: 0,
        subTot: 0,
        // changed: false
      }
    },
    props: {
      wine: {type: Object},
      flag: {type: Boolean}, //serve per aggiornare il subtotale, non toglierlo altrimenti ti terrebbe il prezzo dell'elemento rimosso sull'elemento che "sale"
      qntyProd: {type: Boolean}
    },
    watch: {
      wine: {
        handler: function (val) {
          this.qntyOrd = val.qntyOrd
        },
        deep: true
      },
      qntyProd: function (val) {
        // console.log('qty ', this.qntyProd)
      },
      flag: function (val) {
        if(val){
          this.singlePrice() //serve per aggiornare il subtotale, non toglierlo
        }
      }
    },
    mounted: function () {
      this.qntyOrd = this.wine.qntyOrd
      this.singlePrice()
      // console.log('qty ', this.qntyProd)
    },
    methods: {
      singlePrice: function () {
        this.$http.get('/ws-shop/cart/singlePrice', {
          params: {
            idProduct: this.wine.idProduct,
            qntyOrd: this.qntyOrd
          }
        }).then(response => {
          this.subTot = response.body.price
          this.$forceUpdate()
        })
      },
      removeFromCart: function () {
        this.$http.get('/ws-shop/cart/remove/' + this.wine.idProduct, {params: {idCarrello: localStorage.getItem('idCarrello')}}).then(response => {
          if (response.body.rc === 0) {
            this.$toasted.show(this.$t('prod_rem'), {
              theme: 'primary',
              position: 'bottom-right',
              type: 'success',
              duration: 4000
            })
            this.$emit('update')
          } else {
            this.$toasted.show(this.$t('prb_prod_rem'), {
              theme: 'primary',
              position: 'bottom-right',
              type: 'error',
              duration: 4000
            })
          }
        })
      },
      updateCart: function () {
        let data = {
          idCartEncrypted: localStorage.getItem('idCarrello'),
          idProduct: this.wine.idProduct,
          qntyOrd: this.qntyOrd
        }
        // if(this.changed){
          this.$http.post('/ws-shop/cart/updateQnty', data).then(response => {
            if (response.body.rc === 0) {
              this.$toasted.show(this.$t('prod_up'), {
                theme: 'primary',
                position: 'bottom-right',
                type: 'success',
                duration: 4000
              })
              this.$emit('update')
            } else {
              this.$toasted.show(this.$t('prb_prod_rem'), {
                theme: 'primary',
                position: 'bottom-right',
                type: 'error',
                duration: 4000
              })
            }
          })
        // }
        // this.changed = false
      }
    },
    i18n: {
      fallbackLocale: 'it', // default lang,
      messages: {
        it: {
          prod_rem: 'Prodotto rimosso dal carrello',
          prb_prod_rem: 'Errore',
          prod_up: 'Carrello aggiornato correttamente'
        },
        en: {
          prod_rem: 'Prodotto rimosso dal carrello',
          prb_prod_rem: 'Error',
          prod_up: 'Carrello aggiornato correttamente'
        }
      }
    }
  }
</script>

<style lang="less">

</style>



// WEBPACK FOOTER //
// src/components/DettaglioCarrello.vue